import ENV from "./config.json";
import axios from "axios";
import store from "../store";
import { sendAdmEventTracking, initTreasureTracking } from "../utils/tracking";

const request = axios.create({
  withCredentials: true,
  timeout: process.env.REQUEST_TIMEOUT || 30000,
});

let firstTime = true;

export async function newConfig() {
  let config = store?.endpoint?.state?.config;
  let currentEnvironment = "";
  let currentRegion = "";
  let userProfile = "";
  let ownerProfile = "";
  let regionList = [
    {
      name: "Hà Nội",
      code: "hn",
    },
    {
      name: "Hồ Chí Minh",
      code: "hcm",
    },
  ];

  if (firstTime) {
    firstTime = false;
  } else {
    while (!store?.endpoint?.state?.config) {
      await new Promise((r) => setTimeout(r, 200));
      config = store?.endpoint?.state?.config;
    }
  }

  if (!config) {
    const currentHost = window.location.host;

    if (currentHost.includes("staging2")) {
      currentEnvironment = "staging2";
    } else if (currentHost.includes("staging")) {
      currentEnvironment = "staging";
    } else if (currentHost.includes("uat")) {
      currentEnvironment = "uat";
    } else if (
      currentHost.includes("vc-backup") ||
      currentHost.includes("hapu-backup")
    ) {
      currentEnvironment = "privateBackup";
    } else if (currentHost.includes("local")) {
      currentEnvironment = process?.env?.APP_ENV;
    } else {
      currentEnvironment = "manage";
    }

    if (currentEnvironment !== "privateBackup") {
      const url = `https://${currentEnvironment}.bizflycloud.vn/account/api/context?includes=billing_account,has_expired_invoice,has_expired_payment_request,whitelist,user_regions,token`;
      const urlIam = `https://${currentEnvironment}.bizflycloud.vn/account/api/iam/context?includes=billing_account,has_expired_invoice,has_expired_payment_request,whitelist,user_regions,token`;

      const userResponse = new Promise((resolve) => {
        request({
          url,
          method: "get",
        })
          .then((res) => {
            if (res?.data) {
              return resolve(res?.data);
            }
            resolve();
          })
          .catch((err) => {
            resolve();
          });
      });

      const ownerResponse = new Promise((resolve) => {
        request({
          url: urlIam,
          method: "get",
        })
          .then((res) => {
            if (res?.data) {
              sendAdmEventTracking(res?.data?.tenant_id);
              initTreasureTracking(res?.data?.owner_project_id);
              return resolve(res?.data);
            }
            resolve();
          })
          .catch((err) => {
            resolve();
          });
      });

      [userProfile, ownerProfile] = await Promise.all([
        userResponse,
        ownerResponse,
      ]);
    }

    if (!userProfile?.email && currentEnvironment !== "privateBackup") {
      const redirectUrl = window.location.href;
      const logOutUrl = ENV?.[currentEnvironment]?.ssoUrl;
      window.location.href = `${logOutUrl}/logout?service=${redirectUrl}`;
    } else {
      currentRegion = "hn";

      if (userProfile?.last_region) {
        currentRegion = userProfile?.last_region?.toLowerCase();
      }

      if (userProfile?.user_regions?.length > 0) {
        regionList = userProfile?.user_regions;
      }

      config = {};

      const { services } = (config.base = ENV[currentEnvironment]);

      config.base = {
        ...config.base,
        region: currentRegion,
        environment: currentEnvironment,
      };

      config.services = Object.keys(services).reduce(
        (prev, next) => ({
          ...prev,
          [next]: services?.[next]?.[currentRegion] ?? services?.[next],
        }),
        {}
      );

      config.categories = ENV?.[currentEnvironment]?.categories;

      store?.endpoint?.mutations.UPDATE_CONFIG_ENDPOINT(
        store?.endpoint?.state,
        {
          config,
          currentEnvironment,
          currentRegion,
          regionList,
        }
      );
      store?.services?.mutations.UPDATE_ALL_SERVICE(
        store?.services?.state,
        config?.categories
      );
      store?.user?.mutations.UPDATE_USER_PROFILE(
        store?.user?.state,
        userProfile
      );
      store?.user?.mutations.UPDATE_MY_PROFILE(store?.user?.state, userProfile);
      store?.user?.mutations.UPDATE_OWNER_PROFILE(
        store?.user?.state,
        ownerProfile
      );
      store?.user?.mutations.UPDATE_LOADING_USER_PROFILE(
        store?.user?.state,
        false
      );
    }
  }

  return config;
}
